import { render, staticRenderFns } from "./EpiMultiSelect.vue?vue&type=template&id=ba3f9e38&scoped=true"
import script from "./EpiMultiSelect.vue?vue&type=script&lang=js"
export * from "./EpiMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./EpiMultiSelect.vue?vue&type=style&index=0&id=ba3f9e38&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3f9e38",
  null
  
)

export default component.exports